import { useContext } from "react"
import { GlobalContext } from "../context/GlobalState";
import MovieCard from "./MovieCard"
export const WatchedPage = () => {
  const {watched} =useContext(GlobalContext)
  return (
    <div className="movie-page">
      <div className="container">
        <div className="header">
          <h1 className="heading">My Watched Movie</h1>
        </div>
        {watched.length > 0 ? (
          <div className="movie-grid">
            {watched.map((movie) => (
              <MovieCard movie={movie} type="watched" />
            ))}
          </div>
        ) : (
          <h2 className='no-movies'> No Movies in your Watched</h2>
        )}
      </div>
    </div>
  )
};
